import { Link, useLocation } from "react-router-dom"
import { useAuth } from "@/contexts/AuthContext"
import { LayoutDashboard, Settings, LogOut, User, Users, Car, DollarSign, Package, Building2, FileText, Wrench } from "lucide-react"

export default function Sidebar() {
  const location = useLocation()
  const { user } = useAuth()

  const isActive = (path: string) => location.pathname === path
  
  // Combine firstName and lastName for display
  const userName = user ? `${user.firstName} ${user.lastName}`.trim() : ""

  const navItems = [
    { path: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
    { path: "/users", label: "Users", icon: Users },
    { path: "/ads", label: "Ads", icon: FileText },
    { path: "/moto-brands", label: "Moto Brands", icon: Car },
    { path: "/moto-gear-categories", label: "Moto Gear Categories", icon: Wrench },
    { path: "/action-prices", label: "Action Prices", icon: DollarSign },
    { path: "/plans", label: "Plans", icon: Package },
    { path: "/companies", label: "Companies", icon: Building2 },
    { path: "/settings", label: "Settings", icon: Settings },
  ]

  return (
    <aside className="w-64 h-screen bg-card border-r border-border fixed left-0 top-0 flex flex-col">
      {/* Logo */}
      <div className="p-6 border-b border-border">
        <h1 className="text-xl font-bold text-foreground">Kupi Motor</h1>
        <p className="text-xs text-muted-foreground">Admin Panel</p>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4 space-y-1">
        {navItems.map((item) => {
          const Icon = item.icon
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center gap-3 px-4 py-2.5 rounded-lg transition-colors ${
                isActive(item.path)
                  ? "bg-primary text-primary-foreground"
                  : "text-muted-foreground hover:bg-accent hover:text-foreground"
              }`}
            >
              <Icon size={20} />
              <span>{item.label}</span>
            </Link>
          )
        })}
      </nav>

      {/* User info & Logout */}
      <div className="p-4 border-t border-border space-y-3">
        {user && (
          <div className="flex items-center gap-3 px-4 py-2">
            <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
              <User size={16} className="text-primary" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-foreground truncate">{userName}</p>
              <p className="text-xs text-muted-foreground truncate">{user.email}</p>
            </div>
          </div>
        )}
        <Link
          to="/logout"
          className="flex items-center gap-3 w-full px-4 py-2.5 rounded-lg text-muted-foreground hover:bg-destructive hover:text-destructive-foreground transition-colors"
        >
          <LogOut size={20} />
          <span>Logout</span>
        </Link>
      </div>
    </aside>
  )
}
